import React, { FC, useState } from 'react'
import Slider from 'react-slick'
import LineWithCircle from '../../../atoms/LineWithCircle/LineWithCircle';


interface ServiceListProps {
    customService: any
}

const ServiceList: FC<ServiceListProps> = ({ customService }) => {
    const [activeSlide, setActiveSlide] = useState(0);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ],
        beforeChange: (_oldIndex: number, newIndex: number) => setActiveSlide(pre => {
            if (newIndex === 6) return -1;
            return newIndex;
        }),
        appendDots: (dots: React.ReactNode) => (
            <div style={{ textAlign: "center", marginTop: "10px" }}>
                <ul style={{ display: "flex", justifyContent: "center", gap: "8px", padding: "0px" }}>
                    {dots}
                </ul>
            </div>
        ),
        customPaging: (i: number) => (
            <div
                style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: activeSlide === -1 && i === 6 ? "var(--color-primary)" : i === activeSlide ? "var(--color-primary)" : "transparent",
                    border: "2px solid var(--color-primary)",
                    transition: "background-color 0.3s ease",
                    cursor: 'pointer'
                }}
            />
        ),
    };
    return (
        <div>
            <div className='mt-20 relative md:ml-24 overflow-x-clip sm:ml-4'>
                <Slider {...settings} className='mx-4'>
                    {customService.ServiceList.map((service: any, idx: any) => {
                        return (
                            <div key={idx} className={`border border-darkGreyPrimary rounded-2xl p-8 bg-gradient-to-br from-transparent via-transparent ${service.bgColor} mx-2`}>
                                <div className='font-bold text-xl mb-4 flex gap-2 sm:text-lg'>
                                    <div>👉</div>
                                    <div>{service.title}</div>
                                </div>
                                <LineWithCircle color={`${service.arrowColor}`} />
                                <ul className='list-disc gap-2 flex flex-col mt-4'>
                                    {service.list.map((serv: any, idx: any) => {
                                        return (
                                            <li key={idx} className='text-[#E0E0E0] ml-6 sm:text-sm'>{serv.title}</li>
                                        )
                                    })}
                                </ul>
                            </div>
                        )
                    })}
                </Slider>
            </div>
        </div>
    )
}

export default ServiceList
